import React from 'react';
import { motion } from 'framer-motion';
import { AiOutlineTwitter } from "react-icons/ai";
import { BsLinkedin, BsGithub } from "react-icons/bs";
import { FaMediumM } from "react-icons/fa";
import { FiMail } from "react-icons/fi";

const socialLinks = [
  {
    name: 'GitHub',
    url: 'https://github.com/Uticodes',
    icon: <BsGithub size={20} />,
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/utibe-etim-0a901a107/',
    icon: <BsLinkedin size={20} />,
  },
  {
    name: 'Twitter',
    url: 'https://twitter.com/Uticodes',
    icon: <AiOutlineTwitter size={22} />,
  },
  {
    name: 'Medium',
    url: 'https://medium.com/@utibeetim',
    icon: <FaMediumM size={19} />,
  },
  {
    name: 'Email',
    url: 'mailto:etim.utibe@gmail.com',
    icon: <FiMail size={20} />,
  },
];

const SocialBar = () => {
  return (
    <motion.aside
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
      aria-label="Social media profiles"
      className="fixed bottom-0 left-4 lg:left-8 z-40 hidden md:flex flex-col items-center space-y-3"
    >
      <div className="flex flex-col space-y-3 items-center bg-slate-900/70 backdrop-blur-md p-2 rounded-2xl border border-slate-800/80 shadow-2xl shadow-black/60">
        {socialLinks.map((item) => (
          <a
            key={item.name}
            href={item.url}
            target={item.url.startsWith('mailto:') ? '_self' : '_blank'}
            rel="noopener noreferrer"
            aria-label={item.name}
            title={item.name}
            className="p-2 text-slate-400 hover:text-secondary hover:bg-slate-800/80 rounded-xl transition-all duration-300 hover:scale-110 hover:-translate-y-0.5 group relative"
          >
            {item.icon}
            {/* Tooltip on hover */}
            <span className="pointer-events-none absolute left-full ml-3 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-all duration-200 px-2.5 py-1 text-xs font-medium text-white bg-slate-800/95 backdrop-blur-md rounded-md border border-slate-700 whitespace-nowrap shadow-lg z-50">
              {item.name}
            </span>
          </a>
        ))}
      </div>
      {/* Sleek vertical connecting line */}
      <div className="w-[1.5px] h-10 bg-gradient-to-b from-slate-700 via-slate-800 to-transparent" />
    </motion.aside>
  );
};

export default SocialBar;
